import { Injectable } from '@angular/core';
import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';
import _ from 'lodash';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MonitoringService {
  private appInsights: ApplicationInsights | undefined;

  constructor() {
    if (environment.appInsights.instrumentationKey !== null) {
      this.appInsightsInitializer();
    }
  }

  public logException(exception: Error, severityLevel?: number): void {
    if (this.appInsights === undefined) {
      // eslint-disable-next-line no-console
      console.error(exception);

      return;
    }

    this.appInsights.trackException({ exception, severityLevel });
  }

  public setAuthenticatedUser(userId: string, accountId: string): void {
    if (this.appInsights === undefined) {
      return;
    }

    this.appInsights.setAuthenticatedUserContext(userId, accountId);
  }

  public logoutAuthorizedUser(): void {
    if (this.appInsights === undefined) {
      return;
    }

    this.appInsights.clearAuthenticatedUserContext();
  }

  private appInsightsInitializer(): void {
    this.appInsights = new ApplicationInsights({
      config: {
        autoTrackPageVisitTime: true,
        cookieDomain: 'scm3d.com',
        correlationHeaderExcludedDomains: ['*.queue.core.windows.net'],
        enableAjaxErrorStatusText: true,
        enableAjaxPerfTracking: true,
        enableAutoRouteTracking: true,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
        enableUnhandledPromiseRejectionTracking: true,
        instrumentationKey: environment.appInsights.instrumentationKey ?? undefined,
      },
    });
    this.appInsights.loadAppInsights();

    const telemetryInitializer = (envelope: ITelemetryItem): void => {
      _.set(envelope, 'tags["ai.cloud.role"]', environment.appInsights.cloudRole);
    };

    this.appInsights.addTelemetryInitializer(telemetryInitializer);
  }
}
